export interface ApiGetClaimCompareTranslationRequest {
    patent_id: string;
    source_lang: string;
    trans_lang: string;
    text: string[];
}

export interface ApiGetClaimCompareTranslationResponse {
    data: Record<string, string>;
}

export const GetClaimCompareTranslation = Symbol.for('GetClaimCompareTranslation');

export interface GetClaimCompareTranslation {
    getClaimCompareTranslation(request: ApiGetClaimCompareTranslationRequest): Promise<ApiGetClaimCompareTranslationResponse>;
}